export const configuration = {
  serviceUrls: {
    artworkGenerationUrl: 'https://artworkgeneration.cimpress.io/api/',
    designSpecificationsUrl: 'https://design-specifications.docext.cimpress.io/',
  },
  artworkGenerationApiKey: 'wHydBxUnnqJZYhPadIiEXUsMcuZrqBPdsTS',
  requestor: 'bulma-pdp-herocarousel-fragment',
};
